import authService from '../services/authService';
import { navigatorUiLoggerFor } from './logger';

export const navigatorUiLogger = navigatorUiLoggerFor()({
  loggerUrl: 'https://xuz8jhpptk.execute-api.us-east-1.amazonaws.com/prod/v1/log',
  stage: 'gamma',
  region: 'us-east-1',
  token: authService.currentIdToken,
});
